export const onBoardingStages = {
  ChannelConsentScreen: "ChannelConsent",
  MonthlyPointAllocationScreen: "MonthlyPointAllocation",
  PointAllocationSummaryScreen: "MonthlyPointAllocation",
  CoreValuesScreen: "CoreValues",
};
